import React from 'react';

import {LLBtn2, withCommon} from '../../components';
import {DrawerCloseButton} from '../../pages/user-profile/components';

const IdCardIcon = () => (
    <svg className="easy-membership-prompt__icon-svg" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="30" fill="currentColor" opacity="0.12"/>
        <rect x="14" y="20" width="36" height="24" rx="4" fill="none" stroke="currentColor" strokeWidth="2.5"/>
        <circle cx="26" cy="32" r="5" fill="none" stroke="currentColor" strokeWidth="2.2"/>
        <path d="M20 40c1.2-4 10.8-4 12 0" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
        <path d="M38 29h10M38 35h8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
        <circle cx="46" cy="18" r="7" fill="currentColor"/>
        <path d="M43 18l2.2 2.2 4-4" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const EasyMembershipPrompt = withCommon({
    store: ({store}) => ({
        viewSize: store.site.status.viewSize,
        openPersonalInfoForm: store.user.openPersonalInfoForm,
    }),
    defaultName: 'EasyMembershipPrompt',
    isObserver: true,
    isTrans: true,
})(({trans, viewSize, openPersonalInfoForm, inDestDrawer}) => {
    const body = (
        <div className={`easy-membership-prompt easy-membership-prompt--${viewSize}`}>
            <div className="easy-membership-prompt__icon">
                <IdCardIcon/>
            </div>
            <h2 className="easy-membership-prompt__title">
                {trans('Complete Your Membership Information')}
            </h2>
            <p className="easy-membership-prompt__body">
                {trans('EASY_MEMBERSHIP_PROMPT_BODY')}
            </p>
            <LLBtn2
                customClasses={`easy-membership-prompt__cta ll-btn--accent`}
                onClick={openPersonalInfoForm}
            >
                <span className="easy-membership-cta__label">{trans('Enter My Information')}</span>
            </LLBtn2>
        </div>
    );

    if (!inDestDrawer) {
        return body;
    }

    return (
        <div className="signup-drawer">
            {viewSize === 'desktop' ? (
                <div className="signup-drawer__header">
                    <p>{trans('Complete Your Membership Information')}</p>
                    <DrawerCloseButton/>
                </div>
            ) : (
                <div className="signup__header--mobile">
                    {trans('Complete Your Membership Information')}
                    <DrawerCloseButton/>
                </div>
            )}
            {body}
        </div>
    );
});

export default EasyMembershipPrompt;
